import { render } from "./EmotionRecognitionQuestion.vue?vue&type=template&id=4c4a2e53"
import script from "./EmotionRecognitionQuestion.vue?vue&type=script&lang=js"
export * from "./EmotionRecognitionQuestion.vue?vue&type=script&lang=js"

import "./EmotionRecognitionQuestion.vue?vue&type=style&index=0&id=4c4a2e53&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__